import React from "react";
import App from './App';
import Home from './page';
import { DesenhadorProps } from "./data/cemweb";

export function Desenhador(props: DesenhadorProps) {
  return(
      <App>
          <Home {...props} />
      </App>
  );
}
